import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

const SlotDigit = ({ digit, delay = 0 }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(false);
    const t = setTimeout(() => setAnimate(true), 50 + delay);
    return () => clearTimeout(t);
  }, [digit, delay]);

  return (
    <span className="inline-block h-[1.2em] overflow-hidden relative" style={{ width: '0.65em' }}>
      <span
        className="inline-flex flex-col transition-transform duration-500 ease-out"
        style={{ transform: animate ? `translateY(-${digit * 1.2}em)` : 'translateY(-10.8em)' }}
      >
        {[0,1,2,3,4,5,6,7,8,9].map(n => (
          <span key={n} className="block h-[1.2em] leading-[1.2em] text-center">{n}</span>
        ))}
      </span>
    </span>
  );
};

const SlotCounter = ({ value, className }) => {
  const digits = String(value).split('');

  return (
    <span className={cn('inline-flex items-center', className)}>
      {digits.map((d, i) => (
        <SlotDigit key={`${i}-${digits.length}`} digit={parseInt(d)} delay={i * 80} />
      ))}
    </span>
  );
};

export default SlotCounter;
